import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Boter Kaas en Eieren Layout
 * @description Nested stack navigator for boter-kaas-en-eieren game screens
 */
export default function TicTacToeLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="[sessionId]" />
    </Stack>
  );
}

